import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

type RouteType = {
  id: number;
  name: string;
  component: React.FC;
};

interface RoutesProps {
  data: RouteType[];
}

export const Routes: React.FC<RoutesProps> = ({ data }) => {
  return (
    <div
      className="ads-tabs__routes"
      tabIndex={0}
      data-testid="ads-tabs__routes"
    >
      {data.map(({ name, id, component }) => (
        <div
          role="tabpanel"
          className="ads-tabs__routes"
          id={name}
          aria-labelledby={name}
          key={id}
        >
          <Route
            exact
            path={`/${id}`}
            component={component}
            data-testid="ads-tabs-routes__panel"
          />
        </div>
      ))}
      <Redirect from="/" to="/1" />
    </div>
  );
};
